var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class FlashTransition extends Component {
    constructor() {
        super('FlashTransition', false);
        this.flashType = 'degrade';
        this.parameters = null;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            /*if (location.hash === '#full') sessionStorage.setItem('flash-type', 'full');
            if (location.hash === '#degrade') sessionStorage.setItem('flash-type', 'degrade');*/
            this.flashType = 'full'; //sessionStorage.getItem('flash-type') === 'full' || $(window).width() < 992 ? 'full' : 'degrade';
            $('a[href^="https://"]').on('click', (event) => {
                if (event.currentTarget.hostname !== window.location.hostname)
                    return;
                this.createFlashTransition(false);
            });
            const storedFlashTransition = sessionStorage.getItem('flashTransition');
            if (storedFlashTransition) {
                this.parameters = JSON.parse(storedFlashTransition);
                this.createFlashElement(true);
                setTimeout(() => {
                    $('.flash-transition').remove();
                    sessionStorage.removeItem('flashTransition');
                }, 1000);
            }
            this.success();
        });
    }
    createFlashTransition(createElement = true) {
        const minWidth = $(window).width() * 0.25;
        const minHeight = $(window).height() * 0.25;
        if (this.flashType === 'full') {
            this.parameters = {
                x: 0,
                y: 0,
                width: $(window).width(),
                height: $(window).height(),
                direction: 'horizontal',
                inverted: false
            };
        }
        else {
            switch (Math.floor(Math.random() * 4)) {
                case 0:
                    this.parameters = { x: 0, y: '20%', width: '90%', height: '80%', direction: 'vertical', inverted: false };
                    break;
                case 1:
                    this.parameters = { x: '60%', y: 0, width: '40%', height: '100%', direction: 'horizontal', inverted: false };
                    break;
                case 2:
                    this.parameters = { x: 'calc(25% + var(--site-margin) / 2 + 4px)', y: 0, width: 'calc(75% - var(--site-margin) / 2 - 4px)', height: '100% ', direction: 'vertical', inverted: true };
                    break;
                case 3:
                    this.parameters = { x: 0, y: 0, width: '50%', height: '100%', direction: 'vertical', inverted: false };
                    break;
                case 4:
                    this.parameters = { x: 'calc(12.5% + var(--site-margin) / 2 + 4px)', y: '20%', width: 'calc(87.5% - var(--site-margin) / 2 - 4px)', height: '80%', direction: 'vertical', inverted: false };
                    break;
            }
        }
        sessionStorage.setItem('flashTransition', JSON.stringify(this.parameters));
        if (createElement)
            this.createFlashElement();
    }
    createFlashElement(fadeOut = false) {
        console.log(`flash-transition-${this.parameters.direction} ${this.flashType} ${this.parameters.inverted ? 'inverted' : ''}`);
        const flash = $.parseHTML('<div class="flash-transition position-fixed"></div>').css({
            left: this.parameters.x,
            top: this.parameters.y,
            width: this.parameters.width,
            height: this.parameters.height
        }).addClass(`flash-transition-${this.parameters.direction} ${this.flashType}${this.parameters.inverted ? ' inverted' : ''}`);
        if (fadeOut) {
            setTimeout(() => {
                flash.addClass('fade-out');
            }, 100);
        }
        $('body').append(flash);
    }
}
